/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N5Inputs */

const en_formatter_ref_n5 = /** @type {(inputs: Formatter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integer-like keys sort numerically and move ahead of string keys.`)
};

const ko_formatter_ref_n5 = /** @type {(inputs: Formatter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정수형 키는 숫자 순으로 정렬되어 문자열 키 앞으로 이동합니다.`)
};

const ja_formatter_ref_n5 = /** @type {(inputs: Formatter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整数的なキーは数値順に並び、文字列キーより前に移動します。`)
};

/**
* | output |
* | --- |
* | "Integer-like keys sort numerically and move ahead of string keys." |
*
* @param {Formatter_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n5 = /** @type {((inputs?: Formatter_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n5(inputs)
	if (locale === "ko") return ko_formatter_ref_n5(inputs)
	return ja_formatter_ref_n5(inputs)
});